import Vue from "vue";
import { TENANT_CONFIG } from "@/store/mutation-types";
export default {
  name: "Banner",
  components: {},
  data: function data() {
    return {
      swiperOptions: {
        speed: 800,
        effect: "coverflow",
        //"fade"（淡入）、"cube"（方块）、"coverflow"（3d流）、"flip"（3d翻转）
        //显示分页
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        //设置点击箭头
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        //自动轮播
        autoplay: {
          delay: 5000,
          //当用户滑动图片后继续自动轮播
          disableOnInteraction: false
        },
        //开启循环模式
        loop: true
      },
      banner: [],
      tenantInfo: {},
      tenantConfig: {},
      loading: true
    };
  },
  created: function created() {
    //获取banner数据
    this.tenantConfig = this.$store.getters.tenantInfo;
    console.log(this.tenantConfig);
    if (this.tenantConfig.banner) {
      var banners = this.tenantConfig.banner.split(",");
      if (this.tenantConfig.bannerLinks) {
        var bannerLinks = this.tenantConfig.bannerLinks.split("\n");
      } else {
        var bannerLinks = [];
      }
      for (var i in banners) {
        var b = {};
        b.img = banners[i];
        if (bannerLinks.length > i) {
          b.href = bannerLinks[i];
        }
        this.banner.push(b);
      }
    }
  },
  methods: {}
};